import React, { useEffect } from 'react'
import './SideBar.scss'
import SideBarData from './SideBarData'

function SideBar() {
    useEffect(() => {
        const sections = document.querySelectorAll("section");
        const sideBarLinks = document.querySelectorAll("#sidebar a");
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: .5
        }
        const id = window.location.href.split("#")[1];
        if(id){
            const sideBarLink = document.querySelector(`#sidebar a[href="#${id}"]`);
            sideBarLink.classList.add("active");
            document.querySelector(`#${id}`)?.scrollIntoView();
        }
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const sectionId = entry.target.getAttribute("id");
                const sideBarLink = document.querySelector(`#sidebar a[href="#${sectionId}"`);
                
                if (entry.isIntersecting) {
                    sideBarLink.classList.add("active");
                } else {
                    sideBarLink.classList.remove("active")
                }
            }, observerOptions)
        })

        sections.forEach(section => observer.observe(section));

        return () => {
            observer.disconnect();
        }
    }, [])

    return (
        <div id="sidebar">
            {
                SideBarData.map(category => {
                    return (
                        <div key={category} className='category'>
                            <a className='group' href={`#${category.group.toLowerCase().split(' ').join('-')}-section`}>{category.group}</a>
                            <div className="subgroups-container">
                                {
                                    category.subgroups.map(subgroup => {
                                        return <a key={subgroup} href={`#${subgroup.toLowerCase().split(' ').join('-')}-section`} className="subgroup">{subgroup}</a>
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default SideBar